import { useNavigate } from 'react-router-dom'
import { Monitor, DeviceMobile } from '@phosphor-icons/react'

export default function NoMobileAccess() {
  const navigate = useNavigate()

  const handleLogout = async () => {
    const { supabase } = await import('../lib/supabase')
    await supabase.auth.signOut()
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <Monitor className="w-16 h-16 text-blue-600" weight="duotone" />
            <div className="absolute -bottom-2 -right-2 bg-red-500 rounded-full p-2">
              <DeviceMobile className="w-6 h-6 text-white" weight="bold" />
            </div>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 text-center mb-4">
          Mobile Access Not Available
        </h1>

        {/* Message */}
        <div className="space-y-4 text-gray-600">
          <p>
            You are logged in as an <strong>Organization Administrator only</strong>.
          </p>
          
          <p>
            To access the mobile interface, you need to assign yourself one of these roles:
          </p>

          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Team Leader</li>
            <li>Group Leader</li>
            <li>Subgroup Leader</li>
            <li>Member</li>
          </ul>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6">
            <p className="text-sm text-blue-900">
              <strong>💡 How to fix this:</strong>
            </p>
            <ol className="list-decimal list-inside space-y-1 text-sm text-blue-800 mt-2 ml-2">
              <li>Switch to a desktop device or widen your browser</li>
              <li>Go to the Admin Dashboard</li>
              <li>Navigate to Members → Find yourself</li>
              <li>Assign yourself a leadership role or member status</li>
            </ol>
          </div>
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="w-full mt-8 bg-gray-900 text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors"
        >
          Logout
        </button>
      </div>
    </div>
  )
}